module.exports = new __parcel__URL__("spotlight-image-dark.1ae28b90.svg").toString();